import { useEffect } from 'react';
/**
 * Will wait for a specified amount of time (options.delayTimeMs) before
 * triggering the callback. The callback can be triggered multiple times,
 * if any of its dependencies change (see React.useState).
 * @param callback The callback that is triggered after some delay.
 *                 You should wrap the callback in React.useCallback
 * @param options Specifies additional options to how the delay should work
 * */
var useDelayedCallback = function (callback, options) {
    useEffect(function () {
        var timeout = setTimeout(callback, options.delayTimeMs);
        return function () {
            clearTimeout(timeout);
        };
    }, [callback, options.delayTimeMs]);
};
export default useDelayedCallback;
